// Compare actual instants; adjacent meetings are not overlaps.
export function appointmentConflicts(entries) {
  const result = new Map(entries.map(item => [item, []]));
  const timed = entries.filter(({ event, startTime, endTime }) =>
    !event.isAllDay && !event.canceledAt && !['cancelled', 'canceled', 'declined'].includes(String(event.status).toLowerCase()) &&
    event.transparency !== 'transparent' && String(event.showAs).toLowerCase() !== 'free' &&
    Number.isFinite(+startTime) && Number.isFinite(+endTime) && endTime > startTime
  ).sort((a, b) => a.startTime - b.startTime);
  for (let i = 0; i < timed.length; i += 1) {
    const a = timed[i];
    for (let j = i + 1; j < timed.length && timed[j].startTime < a.endTime; j += 1) {
      const b = timed[j];
      if (a.event.staffId != null && b.event.staffId != null && String(a.event.staffId) !== String(b.event.staffId)) continue;
      if (a.event.id != null && String(a.event.id) === String(b.event.id) && a.event.source === b.event.source && +a.startTime === +b.startTime) continue;
      result.get(a).push(b);
      result.get(b).push(a);
    }
  }
  return result;
}
